import clsx from 'clsx';

const TONES = {
  neutral: 'bg-background-elevated text-foreground-muted border-border',
  success: 'bg-accent-soft text-accent border-accent/30',
  warning: 'bg-warning-soft text-warning border-warning/30',
  danger: 'bg-danger-soft text-danger border-danger/30',
  // Muted slate — matured/closed/info states that shouldn't compete with
  // the primary accent or read as an error.
  info: 'bg-info-soft text-info border-info/30',
};

export default function Badge({ tone = 'neutral', children, className }) {
  return (
    <span
      className={clsx(
        'inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-xs font-medium border',
        TONES[tone],
        className
      )}
    >
      {children}
    </span>
  );
}
